export default {
  install: function(Vue, opt) {
    // 文件大小转换
    Vue.filter("bytesToSize", function(bytes) {
      if (bytes === 0 || bytes === "0") return "0 B";
      let k = 1024;
      let sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      let i = Math.floor(Math.log(bytes) / Math.log(k));
      let num = bytes / Math.pow(k, i);
      return num.toFixed(2) + sizes[i];
    });
    Vue.filter("fileIcon", fileType => {
      return "webImg/list/pdf.png";
    });
    // 列表文件名展示
    Vue.filter("formatListName", function(item) {
      if (item.folderName) return item.folderName;
      const fileNameArr = item.fileName.split(".");
      if (fileNameArr.length !== 0 && fileNameArr.length > 2) {
        fileNameArr.pop();
        return fileNameArr.join(".");
      }
      if (fileNameArr.length !== 0) {
        return fileNameArr[0];
      }
    });
    //打印机参数转换
    Vue.filter("outlineData", function(parameter) {
      if (parameter === "printPaperNum") {
        return "打印纸张";
      } else if (parameter === "printNum") {
        return "打印次数";
      }
      return parameter;
    });
    Vue.filter("stateTransition", function(state) {
      if (Number(state) === -1) {
        return "设置打印参数";
      } else if (Number(state) === 0) {
        return "排队中";
      } else if (Number(state) === 1) {
        return "正在打印";
      } else if (Number(state) === 2) {
        return "打印成功";
      } else if (Number(state) === 3) {
        return "打印失败";
      } else if (Number(state) === 4) {
        return "取消打印";
      } else if (Number(state) === 5) {
        return "等待扫码";
      } else if (Number(state) === 6) {
        return "待转换";
      }
    });
    //打印机参数转换
    Vue.filter("parameterConversion", function(parameter) {
      if (parameter === "double") {
        return "双面";
      } else if (parameter === "single") {
        return "单面";
      } else if (Number(parameter) === 0) {
        return "黑白";
      } else if (Number(parameter) === 1) {
        return "彩色";
      } else if (
        parameter === "double/single" ||
        parameter === "single/double"
      ) {
        return "单面/双面";
      } else if (parameter === "0/1" || parameter === "1/0") {
        return "黑白/彩色";
      }
      return parameter;
    });
    //打印列表class转换
    Vue.filter("stateTransitionClass", function(state) {
      if (Number(state) === -1) {
        return "set";
      } else if (Number(state) === 0) {
        return "inLine";
      } else if (Number(state) === 1) {
        return "printNow";
      } else if (Number(state) === 2) {
        return "printSuccess";
      } else if (Number(state) === 3) {
        return "printError";
      } else if (Number(state) === 4) {
        return "printError";
      }
    });
    //时间格式转换
    Vue.prototype.formatDateTime = function(inputTime) {
      let date = new Date(inputTime);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      return y + "-" + m;
    };
    /**
     * @description: 获取extName
     * @param {*}
     * @return {*}
     */
    Vue.prototype.getExtName = function(fileName) {
      const fileNameArr = fileName.split(".");
      if (fileNameArr.length !== 0 && fileNameArr.length > 2) {
        return fileNameArr.pop().toLowerCase();
      }
      if (fileNameArr.length === 2) {
        return fileNameArr[1].toLowerCase();
      }
      return "";
    };
    /**
     * @description: 获取限制参数值
     * @param {*}
     * @return {*}
     */
    Vue.prototype.getParamValue = function(arr, paramKey) {
      const current = arr.find(item => item.paramKey === paramKey);
      return current ? current.paramValue : undefined;
    };
    //截取文件类型
    Vue.prototype.interceptingFileTypes = function(fileName) {
      let fileType;
      let typeStartIndex = fileName.lastIndexOf(".") + 1;
      let typeEndIndex = fileName.length;
      fileType = fileName.substring(typeStartIndex, typeEndIndex);
      return fileType;
    };
    // 
    Vue.prototype.getCurrentUser = function() {
      return localStorage.getItem("userInfo")? JSON.parse(localStorage.getItem("userInfo")): null;
    };
    // 缩略显示设备属性
    Vue.prototype.getOptions = function(item) {
      // 待优化
      let str = "";
      let pageSizeArr = [];
      let colorArr = [];
      let paperSize = [];
      const options = item.printEquipmentOptionsList;
      if (!options || options.length === 0) return "";
      options.forEach(element => {
        if (element.optionKey === "paperSize")
          paperSize.push(element.optionName);
        if (element.optionKey === "singleDoubleSides")
          pageSizeArr.push(element.optionName);
        if (element.optionKey === "colorMode")
          colorArr.push(element.optionName);
      });
      str = `${paperSize.join("/")}  |  ${pageSizeArr.join(
        "/"
      )}  |  ${colorArr.join("/")}`;
      return str;
    };
    Vue.prototype.copy = function(url) {
      let result;
      // 将复制内容添加到临时textarea元素中
      const tempTextarea = document.createElement("textarea");
      document.body.appendChild(tempTextarea);
      tempTextarea.value = url;
      // 判断设备
      const u = navigator.userAgent;
      if (u.match(/(iPhone|iPod|iPad);?/i)) {
        // iOS
        // 移除已选择的元素
        window.getSelection().removeAllRanges();
        // 创建一个Range对象
        const range = document.createRange();
        // 选中
        range.selectNode(tempTextarea);
        // 执行选中元素
        window.getSelection().addRange(range);
        // 复制
        result = document.execCommand("copy");
        // 移除选中元素
        window.getSelection().removeAllRanges();
      } else {
        // 选中
        tempTextarea.select();
        // 复制
        result = document.execCommand("Copy");
      }
      // 移除临时文本域
      document.body.removeChild(tempTextarea);
      if (result) {
        this.popup = false;
        this.$message.success("复制成功");
      } else {
        this.popup = false;
        this.$alert({
          subTitle: "复制失败",
          description: "该浏览器不支持复制"
        });
      }
      return result;
    };
  }
};
